// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@font-face{font-family:\"Geometria\";src:url(/fonts/subset-Geometria.woff2) format(\"woff2\"),url(/fonts/subset-Geometria.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:fallback}@font-face{font-family:\"Geometria\";src:url(/fonts/subset-Geometria-Medium.woff2) format(\"woff2\"),url(/fonts/subset-Geometria-Medium.woff) format(\"woff\");font-weight:500;font-style:normal;font-display:fallback}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
